import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'

import { ref, watch } from "vue";

// PC端路由
const routesPc =  [
    {
       path:'/',
      name: 'Home',
      component: () => import('@/views/home.vue'),
    },

  {
    path: '/payments',
    name: 'pcdmcstore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/mdmcstore.vue'),
    meta: {
        title: 'Payment Center',
        showTab: false,
      },
  },
  {
    path: '/dmcpoc',
    name: 'pcnewdmcstore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/pcnewdmcstore.vue'),
    meta: {
        title: 'Payment Center',
        favicon: 'dmc.ico',
        showTab: false,
      },
  },

  {
    path: '/st',
    name: 'pcnewststore',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/mnewststore.vue'),
    meta: {
        title: 'Payment Center',
        favicon: 'st.ico',
        showTab: false,
      },
  },

  // {
  //   path: '/bap',
  //   name: 'pcbapstore',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('@/views/pcbapstore.vue'),
  //   meta: {
  //       title: 'Payment Center',
  //       favicon: 'bap.ico',
  //       showTab: false,
  //     },
  // },
  {
    path: '/success',
    name: 'pcsuccess',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/pcsecond/pcsuccess.vue'),
    meta: {
        title: 'Payment Center',
        showTab: false,
      },
  },
  {
    path: '/fail',
    name: 'pcfail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/pcsecond/pcfail.vue'),
    meta: {
        title: 'Payment Center',
        showTab: false,
      },
  },

]


// 移动端路由表
const routesMB = [
  {
    path:'/',
   name: 'Home',
   component: () => import('@/views/home.vue'),
 },
  {
    path: '/payments',
    name: 'mdmcstore',
    component: () => import('@/views/mdmcstore.vue'),
    meta: {
        title: 'Payment Center',
        showTab: false,
      },
  },
  {
    path: '/dmcpoc',
    name: 'mdnewmcstore',
    component: () => import('@/views/mnewdmcstore.vue'),
    meta: {
        title: 'Payment Center',
        favicon: 'dmc.ico',
        showTab: false,
      },
  },
  {
    path: '/st',
    name: 'mnewststore',
    component: () => import('@/views/mnewststore.vue'),
    meta: {
        title: 'Payment Center',
        favicon: 'st.ico',
        showTab: false,
      },
  },
  // {
  //   path: '/bap',
  //   name: 'mbapstore',
  //   component: () => import('@/views/mbapstore.vue'),
  //   meta: {
  //       title: 'Payment Center',
  //       favicon: 'bap.ico',
  //       showTab: false,
  //     },
  // },
  {
    path: '/success',
    name: 'msuccess',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/msecond/msuccess.vue'),
    meta: {
        title: 'Payment Center',
        showTab: false,
      },
  },
  {
    path: '/fail',
    name: 'mfail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/msecond/mfail.vue'),
    meta: {
        title: 'Payment Center',
        showTab: false,
      },
  },

]

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes
// })

// 声明变量用来接routers
var routes = [];
const screenWidth = ref()
// 获取页面宽度
screenWidth.value = document.body.clientWidth
if (screenWidth.value <= 1200) {
    console.log('is Mobile');

    routes = routesMB
} else {
    console.log('pc')
    routes = routesPc
}
window.onresize = () => {
    screenWidth.value = document.body.clientWidth;
};
// 监听页面宽度
watch(screenWidth, (newVal, oldVal) => {
    let timer = setTimeout(() => {
        if (newVal <= 1200) {
            // 小于758就是移动端 就把移动端路由表赋给routes
            console.log('is Mobile');
            routes = routesMB
            window.location.reload()
        } else {
            console.log('pc')
            // 大于就是pc端，把pc端路由表赋给routes
            routes = routesPc
            window.location.reload()
        }
        // 重绘页面
    }, 500)
    return () => {
        // 清除定时器
        clearTimeout(timer)
    }
}, {
    // 深度清除
    deep: true,
})
 
 
 
const router = createRouter({
    history: createWebHistory(),
    routes,
   
})


router.beforeEach((to, from, next) => {
    document.title = (to?.meta?.title) || document.title;
    updateFavicon(to.meta.favicon);
    next();
  })
  

  function updateFavicon(iconName) {
    const favicon = document.getElementById('dynamic-favicon');
    if (favicon && iconName) {
      // 添加时间戳防止缓存
      const newHref = `${process.env.BASE_URL}${iconName}?t=${Date.now()}`;
      favicon.href = newHref;
    }
  }

export default router
